import React, { useEffect, useState } from "react";
import classes from "./HomePage.module.css";
import LinedSection from "../component/LinedSection";
import { fetchAndroidGamesApi, fetchGamesApi } from "../http/http";
import { FaStarOfLife, FaChevronDown } from "react-icons/fa";
import { Swiper, SwiperSlide } from "swiper/react";
import {
    Autoplay,
    Navigation,
    Pagination,
    Scrollbar,
    A11y,
    Keyboard,
    EffectCoverflow,
} from "swiper/modules";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";
import { FaStar, FaChevronLeft, FaChevronRight } from "react-icons/fa";
import { motion } from "framer-motion";
import LogoCarousel from "../component/LogoCarousel";
import TopGames from "../component/TopGames";
import Footer from "../component/Footer";
import { useLocation, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import SectionHeading from "../component/SectionHeading";
import GamesCarousel from "../component/GamesCarousel";
import CategorySection from "../component/CategorySection";
import ActionGames from "../component/ActionGames";
import PuzzleGames from "../component/PuzzleGames";
import GamesCarousel2 from "../component/GamesCarousel2";
import SectionTopUvPlayed from "../component/SectionTopUvPlayed";
import FooterCarousel from "../component/FooterCarousel";
import EducationGames from "../component/EducationGames";
import CasualGames from "../component/CasualGames";
import { useTranslation } from "react-i18next";
import AndroidGames from "../component/AndroidGames";

const HomePage = () => {

    const [categories, setCategories] = useState([]);
    const [games, setGames] = useState([]);
    const [allGames, setAllGames] = useState([]);
    const [loading, setLoading] = useState(false);
    const [popularGames, setPopularGames] = useState([]);
    const [topUvPlayedGames, setTopUvPlayedGames] = useState([]);
    const [categoryWiseGames, setCategoryWiseGames] = useState([]);

    const [androidGames,setAndroidGames]=useState([]);

    const selectedLanguageId = Number(
        useSelector((state) => state?.persisted?.languageSlice?.language ?? 1)
    );

    const { user } = useSelector(state => state?.persisted?.userSlice);
    const { t } = useTranslation();

    const navigate = useNavigate();

    const pickRandomK = (arr, k = 20) => {
        const n = Array.isArray(arr) ? arr.length : 0;
        if (n <= k) return arr ? [...arr] : [];

        const idx = new Set();
        while (idx.size < k) {
            idx.add(Math.floor(Math.random() * n));
        }
        return Array.from(idx, (i) => arr[i]);
    };

    const fetchGames = async (language) => {
        try {
            setLoading(true);
            const response = await fetchGamesApi(language);
            const response2=await fetchAndroidGamesApi(language);
            console.log(response2?.data?.games,'android games==');
            setAndroidGames(response2?.data?.games);
            setAllGames(response?.data?.games);
            setGames(response?.data?.games);
            setCategories(response?.data?.categories);
            setPopularGames(pickRandomK(response?.data?.games, 5));
            setTopUvPlayedGames(pickRandomK(response?.data?.games, 5));

            const allGamesData = response?.data?.games || [];
            const categoriesData = response?.data?.categories || [];

            setCategoryWiseGames(
                categoriesData.map((category) => ({
                    category,
                    games:
                        String(category.id) === "0"
                            ? allGamesData
                            : allGamesData.filter(
                                (game) => String(game.category_id) === String(category.id)
                            ),
                }))
            );
            setLoading(false);
        } catch (error) {
            console.log(error, 'error--');
            setLoading(false);
        }
    }

    console.log(categoryWiseGames, 'cwg');

    useEffect(() => {
        fetchGames(selectedLanguageId);
    }, [selectedLanguageId]);

    console.log(allGames, 'al');

    const renderSkeletonCards = (count, firstLarge = false) => {
        return Array.from({ length: count }).map((_, index) => {
            const isLarge = firstLarge && index === 0;

            return (
                <div
                    key={`skeleton-${firstLarge ? "top" : "bottom"}-${index}`}
                    className={`${classes.game_card} ${isLarge ? classes.large_card : classes.small_card
                        } ${classes.skeletonCard}`}
                >
                    <div className={classes.skeletonImage}></div>

                    <div className={classes.skeletonContent}>
                        <div className={classes.skeletonMetaRow}>
                            <span className={classes.skeletonMeta}></span>
                            <span className={classes.skeletonChip}></span>
                        </div>

                        <span
                            className={`${classes.skeletonTitle} ${isLarge
                                ? classes.skeletonTitleLarge
                                : classes.skeletonTitleSmall
                                }`}
                        ></span>

                        <span
                            className={`${classes.skeletonTitle} ${isLarge
                                ? classes.skeletonTitleMedium
                                : classes.skeletonTitleTiny
                                }`}
                        ></span>
                    </div>
                </div>
            );
        });
    };


    return (
        <main className={classes.main}>
            <section
                className={classes.heroSection}
                style={{
                    backgroundImage: "url('/images/feature-bg.png')",
                }}
            >
                <LinedSection />

                <header className={classes.topBar}>
                    <div className={classes.brand}>
                        <div className={classes.brand_container}>
                            <img src="/images/uvgamingtogo.png" alt="uv gaming" className={classes.uv_logo} loading="lazy" />
                            <div className={classes.brandSub}>Powered by Vodacom</div>
                        </div>
                    </div>

                    <div className={classes.topActions}>
                        <button className={classes.btnGhost} onClick={() => navigate("/winners")}>{t("55")}</button>
                        <button className={classes.btnGhost} onClick={() => navigate("/leaderboard")}>{t("56")}</button>
                        <button className={classes.btnGhost} onClick={() => navigate("/profile")}>{t("57")}</button>
                    </div>
                </header>

                <div className={classes.container}>
                    <div className={classes.row}>
                        {/* LEFT IMAGE */}
                        <div className={`${classes.col} ${classes.colLeft}`}>
                            <div className={`${classes.heroImageWrap} ${classes.slideInLeft}`}>
                                <img
                                    className={classes.heroImage}
                                    src="/images/hero-section-vector-image.png"
                                    alt="hero"
                                    loading="lazy"
                                />
                            </div>
                        </div>

                        {/* RIGHT CONTENT */}
                        <div className={`${classes.col} ${classes.colRight}`}>
                            <div className={classes.heroContent}>
                                <h6 className={classes.subtitle}>
                                    {t("58")}
                                </h6>

                                <h1 className={classes.title}>
                                    {t("59")} <br />
                                    {t("60")}
                                </h1>

                                <p className={`${classes.desc} ${classes.fadeInUp}`}>
                                    {t("61")}
                                </p>

                                <div className={`${classes.btnRow} ${classes.fadeInUpDelay}`}>
                                    {/* <button type="button" className={classes.btnPrimary}
                                    onClick={()=>navigate("/home#games")}
                                    >
                                        Explore Games
                                    </button> */}

                                    {/* <button type="button" className={classes.btnOutline}>
                                        Explore
                                    </button> */}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Optional overlay for better contrast */}
                <div className={classes.overlay} />
            </section>

            <LogoCarousel />

            {loading ? (
                <>
                    <section className={classes.games_section_main}>
                        <div className={classes.section_glow_left} />
                        <div className={classes.section_glow_right} />

                        <section className={classes.games_section}>
                            {renderSkeletonCards(5, true)}
                        </section>
                    </section>
                </>
            ) : (
                <>
                    {/* <section className={classes.games_section_main}>
                        <div className={classes.section_glow_left} />
                        <div className={classes.section_glow_right} />

                        <SectionHeading />

                        <section className={classes.games_section}>
                            {topUvPlayedGames?.slice(0, 5).map((game, index) => {
                                const isLarge = index === 0 || index === 5;

                                return (
                                    <motion.article
                                        key={`${game.id}-${index}`}
                                        layout
                                        whileHover={{ y: -10, scale: 1.015 }}
                                        transition={{ type: "spring", stiffness: 220, damping: 18 }}
                                        onClick={() => navigate("/game", {
                                            state: {
                                                game: game
                                            }
                                        })}
                                        className={`${classes.game_card} ${isLarge ? classes.large_card : classes.small_card
                                            }`}
                                    >
                                        <div className={classes.media_wrap}>
                                            <img
                                                src={game.game_banner}
                                                loading="lazy"
                                                alt={game.game_name}
                                                className={classes.game_image}
                                            />
                                        </div>

                                        <div className={classes.overlay_in_card} />
                                        <div className={classes.overlay_top} />
                                        <div className={classes.card_border_glow} />
                                        <div className={classes.card_shine} />

                                        <div
                                            className={`${classes.card_content} ${isLarge ? classes.card_content_large : classes.card_content_small
                                                }`}
                                        >
                                            <div className={classes.meta_row}>
                                                <p className={classes.game_category}>{game.category_name}</p>
                                                <span className={classes.play_chip}>Play now</span>
                                            </div>

                                            <h3
                                                className={`${classes.game_name} ${isLarge ? classes.large_title : classes.small_title
                                                    }`}
                                            >
                                                {game.game_name}
                                            </h3>

                                            <div className={classes.bottom_accent} />
                                        </div>
                                    </motion.article>
                                );
                            })}
                        </section>
                    </section> */}

                    <section className={classes.games_section_main}>
                        <div className={classes.section_glow_left} />
                        <div className={classes.section_glow_right} />

                        <div className={classes.red_swoosh_container}>
                            <img src="/images/red-swoosh.png" alt="red swoosh" className={classes.red_swoosh_img} />
                        </div>
                        <SectionHeading />
                        <CategorySection categories={categories} />
                    </section>


                    <ActionGames categoryWiseGames={categoryWiseGames} />

                    <PuzzleGames categoryWiseGames={categoryWiseGames} />

                    <TopGames
                        games={popularGames}
                    />

                    <GamesCarousel categoryWiseGames={categoryWiseGames} />

                    {/* Top UV Played Games */}
                    <SectionTopUvPlayed topUvPlayedGames={topUvPlayedGames} />

                    <EducationGames categoryWiseGames={categoryWiseGames} />

                    <CasualGames categoryWiseGames={categoryWiseGames} />

                    <AndroidGames androidGames={androidGames} />

                    {/* <GamesCarousel2 categoryWiseGames={categoryWiseGames} /> */}

                    {/* <section className={classes.games_section_main}>
                        <div className={classes.section_glow_left} />
                        <div className={classes.section_glow_right} />

                        <section className={classes.games_section}>
                            {games?.slice(5).map((game, index) => {
                                const isLarge = false;

                                return (
                                    <motion.article
                                        key={`${game.id}-${index}`}
                                        layout
                                        whileHover={{ y: -10, scale: 1.015 }}
                                        transition={{ type: "spring", stiffness: 220, damping: 18 }}
                                        className={`${classes.game_card} ${isLarge ? classes.large_card : classes.small_card
                                            }`}
                                        onClick={() => navigate("/game", {
                                            state: {
                                                game: game
                                            }
                                        })}
                                    >
                                        <div className={classes.media_wrap}>
                                            <img
                                                src={game.game_banner}
                                                alt={game.game_name}
                                                loading="lazy"
                                                className={classes.game_image}
                                            />
                                        </div>

                                        <div className={classes.overlay_in_card} />
                                        <div className={classes.overlay_top} />
                                        <div className={classes.card_border_glow} />
                                        <div className={classes.card_shine} />

                                        <div
                                            className={`${classes.card_content} ${isLarge ? classes.card_content_large : classes.card_content_small
                                                }`}
                                        >
                                            <div className={classes.meta_row}>
                                                <p className={classes.game_category}>{game.category_name}</p>
                                                <span className={classes.play_chip}>Play now</span>
                                            </div>

                                            <h3
                                                className={`${classes.game_name} ${isLarge ? classes.large_title : classes.small_title
                                                    }`}
                                            >
                                                {game.game_name}
                                            </h3>

                                            <div className={classes.bottom_accent} />
                                        </div>
                                    </motion.article>
                                );
                            })}
                        </section>
                    </section> */}

                    <FooterCarousel />

                    <Footer />
                </>
            )}




        </main>
    );
};

export default HomePage;